
import React, { useState } from 'react';
import { Card, Button, Container, Row, Col, Modal, Form } from 'react-bootstrap';
import { getFirestore, collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import styled from 'styled-components';
import aiResponses from '../../data/onboarding-ai-responses'; // ✅ Modular AI response import
import candlestickData from '../../data/onboarding-candlestick-data'; // ✅ Modular Candlestick Data


import LearnWithAI from '../../components/ai/LearnWithAI';

import AnswerFeedback from '../../components/practicesession/AnswerFeedback';

// Styled Components
const StyledContainer = styled(Container)`
  background-color: #232830;
  color: #FFFFFF;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
`;

const StyledHeading = styled.h2`
  font-size: 22px;
  font-weight: bold;
  color: #FF7C24;
  margin-bottom: 20px;
  text-align: center;
  margin-top: 10px;
`;

const QuestionText = styled.h3`
  font-size: 20px;
  font-weight: bold;
  color: #FFFFFF;
  text-align: center;
  margin-bottom: 20px;
`;

const StyledCard = styled(Card)`
  background-color: ${(props) => (props.selected ? (props.isCorrect ? '#2ECC71' : '#FF4C4C') : '#FFFFFF')};
  color: ${(props) => (props.selected ? '#FFFFFF' : '#232830')};
  border-radius: 15px;
  padding: 15px;
  margin-bottom: 10px;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  transition: transform 0.2s ease-in-out;
  &:hover {
    transform: scale(1.02);
  }
`;

const StandardButton = styled(Button)`
  background-color: ${(props) => (props.disabled ? '#555' : '#FF7C24')};
  border-color: ${(props) => (props.disabled ? '#555' : '#FF7C24')};
  color: #FFFFFF;
  font-size: 18px;
  font-weight: bold;
  border-radius: 12px;
  padding: 12px;
  width: 80%;
  max-width: 300px;
  margin-top: 20px;
  transition: background-color 0.2s ease-in-out;
  &:hover {
    background-color: ${(props) => (props.disabled ? '#555' : '#E66A1A')};
    border-color: ${(props) => (props.disabled ? '#555' : '#E66A1A')};
  }
`;

const OnboardingTrueFalseQuestion = ({ question, onNext }) => {
  const [selectedOption, setSelectedOption] = useState(null);
  const [isCorrect, setIsCorrect] = useState(false);
  const [showFeedback, setShowFeedback] = useState(false);
  const [showAIChat, setShowAIChat] = useState(false);
  const [messages, setMessages] = useState([]);

  const db = getFirestore();
  const auth = getAuth();

  const handleOptionSelect = async (optionText, optionValue) => {
    if (selectedOption === null) {
      setSelectedOption(optionValue);
      const correct = Number(question.correctanswer) === optionValue;
      setIsCorrect(correct);
      setShowFeedback(true);

      try {
        const currentUser = auth.currentUser;
        await addDoc(collection(db, 'userpracticesessionanswers'), {
          date: serverTimestamp(),
          lessonid: question.lessonid,
          questionid: question.questionid,
          submittedanswer: optionValue,
          userid: currentUser ? currentUser.uid : 'anonymous',
          iscorrect: correct,
        });
      } catch (error) {
        console.error('Error logging answer:', error);
      }
    }
  };

  const handleContinue = () => {
    onNext(isCorrect);
    setShowFeedback(false);
    setSelectedOption(null);
    setIsCorrect(false);
    setMessages([]);
    setShowAIChat(false);
  };

  const handleLearnWithAI = () => {
    const responses = aiResponses[question.questionid] || [];
    const randomResponse = responses.length > 0
      ? responses[Math.floor(Math.random() * responses.length)]
      : "Let's break it down together! Ask me anything about this.";

    setMessages([{ sender: 'ai', text: randomResponse }]);
    setShowAIChat(true);
  };

  return (
    <StyledContainer>
      <StyledHeading>True or False</StyledHeading>
      <QuestionText>{question.questionname}</QuestionText>

      <Row className="g-3" style={{ marginTop: '20px' }}>
        {[{ text: "✅ True", value: 1 }, { text: "❌ False", value: 2 }].map((option) => (
          <Col xs={12} key={option.value}>
            <StyledCard
              onClick={() => handleOptionSelect(option.text, option.value)}
              selected={selectedOption === option.value}
              isCorrect={selectedOption === option.value ? isCorrect : null}
            >
              {option.text}
            </StyledCard>
          </Col>
        ))}
      </Row>

      {showFeedback && (
        <>
          <p style={{ fontSize: '18px', fontWeight: 'bold', color: isCorrect ? '#2ECC71' : '#FF4C4C' }}>
            {isCorrect ? "✅ Correct! Click Continue." : "❌ Incorrect. Click Continue."}
          </p>
          <StandardButton onClick={handleContinue}>Continue</StandardButton>
          <Button
            onClick={handleLearnWithAI}
            style={{
              backgroundColor: '#007bff',
              color: '#fff',
              marginTop: '10px',
              borderRadius: '10px',
              fontSize: '16px',
              fontWeight: 'bold'
            }}
          >
            Learn with AI
          </Button>
        </>
      )}

      <Modal show={showAIChat} onHide={() => setShowAIChat(false)} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>AI Tutor</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {messages.map((msg, idx) => (
            <div
              key={idx}
              style={{
                backgroundColor: msg.sender === 'ai' ? '#232830' : '#007bff',
                color: '#fff',
                padding: '10px',
                borderRadius: '10px',
                marginBottom: '10px',
                textAlign: msg.sender === 'ai' ? 'left' : 'right'
              }}
            >
              {msg.text}
            </div>
          ))}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowAIChat(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </StyledContainer>
  );
};

export default OnboardingTrueFalseQuestion;



// import React, { useState } from 'react';
// import { Card, Button, Container, Row, Col } from 'react-bootstrap';
// import { getFirestore, collection, addDoc, serverTimestamp } from 'firebase/firestore';
// import { getAuth } from 'firebase/auth';
// import styled from 'styled-components';

// // ✅ Styled Components for UI
// const StyledContainer = styled(Container)`
//   background-color: #232830;
//   color: #FFFFFF;
//   min-height: 100vh;
//   display: flex;
//   flex-direction: column;
//   justify-content: center;
//   align-items: center;
//   padding: 20px;
// `;

// // ✅ Styled Heading for "True or False"
// const StyledHeading = styled.h2`
//   font-size: 22px;
//   font-weight: bold;
//   color: #FF7C24;
//   margin-bottom: 20px;
//   text-align: center;
//   margin-top: 10px;
// `;

// const QuestionText = styled.h3`
//   font-size: 20px;
//   font-weight: bold;
//   color: #FFFFFF;
//   text-align: center;
//   margin-bottom: 20px;
// `;

// const StyledCard = styled(Card)`
//   background-color: ${(props) => (props.selected ? (props.isCorrect ? '#2ECC71' : '#FF4C4C') : '#FFFFFF')};
//   color: ${(props) => (props.selected ? '#FFFFFF' : '#232830')};
//   border-radius: 15px;
//   padding: 15px;
//   margin-bottom: 10px;
//   text-align: center;
//   font-size: 18px;
//   font-weight: bold;
//   cursor: pointer;
//   transition: transform 0.2s ease-in-out;
//   &:hover {
//     transform: scale(1.02);
//   }
// `;

// // ✅ Standardized "Continue" Button
// const StandardButton = styled(Button)`
//   background-color: ${(props) => (props.disabled ? '#555' : '#FF7C24')};
//   border-color: ${(props) => (props.disabled ? '#555' : '#FF7C24')};
//   color: #FFFFFF;
//   font-size: 18px;
//   font-weight: bold;
//   border-radius: 12px;
//   padding: 12px;
//   width: 80%;
//   max-width: 300px;
//   margin-top: 20px;
//   transition: background-color 0.2s ease-in-out;
//   &:hover {
//     background-color: ${(props) => (props.disabled ? '#555' : '#E66A1A')};
//     border-color: ${(props) => (props.disabled ? '#555' : '#E66A1A')};
//   }
// `;

// const OnboardingTrueFalseQuestion = ({ question, onNext }) => {
//   const [selectedOption, setSelectedOption] = useState(null);
//   const [isCorrect, setIsCorrect] = useState(false);
//   const [showFeedback, setShowFeedback] = useState(false);

//   const db = getFirestore();
//   const auth = getAuth();

//   // const handleOptionSelect = async (option) => {
//   //   if (selectedOption === null) {
//   //     setSelectedOption(option);

//   //     // ✅ Determine if the answer is correct
//   //     const correct = option === question.correctanswer;
//   //     setIsCorrect(correct);
//   //     setShowFeedback(true);

//   //     // ✅ Store answer in Firestore
//   //     try {
//   //       const currentUser = auth.currentUser;
//   //       await addDoc(collection(db, 'userpracticesessionanswers'), {
//   //         date: serverTimestamp(),
//   //         lessonid: question.lessonid,
//   //         questionid: question.questionid,
//   //         submittedanswer: option,
//   //         userid: currentUser ? currentUser.uid : 'anonymous',
//   //         iscorrect: correct,
//   //       });
//   //     } catch (error) {
//   //       console.error('Error logging answer:', error);
//   //     }
//   //   }
//   // };

//   const handleOptionSelect = async (optionText, optionValue) => {
//     if (selectedOption === null) {
//       setSelectedOption(optionValue); // Store the numeric value instead of emoji text
  
//       // ✅ Convert correctanswer from string to a number for accurate comparison
//       const correct = Number(question.correctanswer) === optionValue;
//       setIsCorrect(correct);
//       setShowFeedback(true);
  
//       // ✅ Store answer in Firestore
//       try {
//         const currentUser = auth.currentUser;
//         await addDoc(collection(db, 'userpracticesessionanswers'), {
//           date: serverTimestamp(),
//           lessonid: question.lessonid,
//           questionid: question.questionid,
//           submittedanswer: optionValue, // Save numeric value (1 or 2)
//           userid: currentUser ? currentUser.uid : 'anonymous',
//           iscorrect: correct,
//         });
//       } catch (error) {
//         console.error('Error logging answer:', error);
//       }
//     }
//   };
  




//   const handleContinue = () => {
//     onNext(isCorrect);
//     setShowFeedback(false);
//     setSelectedOption(null);
//     setIsCorrect(false);
//   };

//   return (
//     <StyledContainer>
//       {/* ✅ Added "True or False" text at the top */}
//       <StyledHeading>True or False</StyledHeading>

//       <QuestionText>{question.questionname}</QuestionText>

//       {/* <Row className="g-3">
//         {["✅ True", "❌ False"].map((option, index) => (
//           <Col xs={12} key={index}>
//             <StyledCard
//               onClick={() => handleOptionSelect(option)}
//               selected={selectedOption === option}
//               isCorrect={isCorrect}
//             >
//               {option}
//             </StyledCard>
//           </Col>
//         ))}
//       </Row> */}


// <Row className="g-3" style={{ marginTop: '20px' }}>
//   {[{ text: "✅ True", value: 1 }, { text: "❌ False", value: 2 }].map((option) => (
//     <Col xs={12} key={option.value}>
//       <StyledCard
//         onClick={() => handleOptionSelect(option.text, option.value)}
//         selected={selectedOption === option.value}
//         isCorrect={selectedOption === option.value ? isCorrect : null}
//       >
//         {option.text}
//       </StyledCard>
//     </Col>
//   ))}
// </Row>


//       {/* {showFeedback && (
//         <p style={{ fontSize: '18px', fontWeight: 'bold', color: isCorrect ? '#2ECC71' : '#FF4C4C' }}>
//           {isCorrect ? "✅ Correct! Click Continue." : "❌ Incorrect. Click Continue."}
//         </p>
//       )} */}

// {showFeedback && (
//   <p style={{ fontSize: '18px', fontWeight: 'bold', color: isCorrect ? '#2ECC71' : '#FF4C4C' }}>
//     {isCorrect ? "✅ Correct! Click Continue." : "❌ Incorrect. Click Continue."}
//   </p>
// )}


//       {showFeedback && (
//         <StandardButton onClick={handleContinue}>Continue</StandardButton>
//       )}
//     </StyledContainer>
//   );
// };

// export default OnboardingTrueFalseQuestion;
